
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M59 57V24.9H1V57z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M9.61 57l5.96-9.09h28.86L50.39 57M15.72 47.91V24.75M44.29 47.91V24.75M8.02 25.01v-8.25h7.64v8.25M44.34 25.01v-8.25h7.65v8.25M13.18 16.76h33.64M44.29 16.52a14.29 14.29 0 10-28.57 0M22.83 47.91V32.22h14.34v15.69M30 32.22v15"}})])
          )
        }
      }
    